<template>
	<div>
		<div class="modal fade" id="CatModal" data-backdrop="static">
			<div class="modal-dialog" role="document">
				<div
					class="modal-content"
					style="min-width: 800px; margin: 0 auto"
				>
					<div class="modal-header">
						<button
							type="button"
							class="close"
							data-dismiss="modal"
							aria-label="Close"
						>
							<span aria-hidden="true">&times;</span>
						</button>
						<h4 class="modal-title" id="myModalLabel">
							Colaborador
						</h4>
					</div>
					<div class="modal-body">
						<div class="col-sm-3">
							<span>CPF</span>
							<input
								type="text"
								v-model="data.CPF"
								v-mask="'###.###.###-##'"
								placeholder="999.999.999-99"
								class="form-control"
							/>
						</div>

						<div class="col-sm-6">
							<span>Nome</span>

							<input
								type="text"
								v-model="data.nome"
								class="form-control"
								placeholder="NOME"
							/>
						</div>

						<div class="col-sm-3">
							<span>Setor</span>
							<input
								type="text"
								v-model="data.setor"
								class="form-control"
								placeholder="SETOR"
							/>
						</div>

						<div class="col-sm-4">
							<span>Cargo</span>
							<select
								v-model="data.cargo"
								class="form-control"
								placeholder="CARGO"
							>
								<option
									v-for="(cargo, index) in cargos"
									:key="index"
									:value="cargo.nome_cargo"
								>
									{{ cargo.nome_cargo }}
								</option>
							</select>
						</div>

						<div class="col-sm-5">
							<span>CBO</span>
							<input
								type="text"
								v-model="data.CBO"
								class="form-control"
								placeholder="CBO"
							/>
						</div>

						<div class="col-sm-3">
							<span>RG</span>
							<input
								type="text"
								v-model="data.RG"
								class="form-control"
								v-mask="'##.###.###-#'"
								placeholder="99.999.999-9"
							/>
						</div>

						<div class="col-sm-4">
							<span>NAVIO</span>
							<div class="add-more-section">
								<select
									v-model="data.navio"
									class="form-control"
									value="data.navio"
								>
									<option
										v-for="(navio, index) in this.navios"
										:key="index"
										:value="navio.navio"
									>
										{{ navio.navio }}
									</option>
								</select>
							</div>
						</div>

						<div class="col-sm-8">
							<span>Empresa</span>
							<select v-model="data.empresa" class="form-control">
								<option
									v-for="(empresa, index) in empresas"
									:key="index"
									:value="empresa.razao_social"
								>
									{{ empresa.razao_social }}
								</option>
							</select>
						</div>

						<div class="col-sm-4">
							<span>Passaporte</span>
							<input
								type="text"
								v-model="data.passaporte"
								class="form-control"
								placeholder="PASSAPORTE"
							/>
						</div>

						<div class="col-sm-4">
							<span>Data de Nascimento</span>
							<input
								type="text"
								v-model="data.dataNasc"
								class="form-control"
								v-mask="'##/##/####'"
								placeholder="01/01/1970"
							/>
						</div>

						<div class="col-sm-4">
							<span>Sexo</span>
							<!-- <input type="text" v-model="data.sexo" class="form-control"> -->
							<select
								name=""
								id=""
								v-model="data.sexo"
								class="form-control"
								aria-label="Default select example"
							>
								<option value="Masculino">Masculino</option>

								<option value="Feminino">Feminino</option>

								<option value="Outro">Outro</option>
							</select>
						</div>

						<div class="col-sm-4">
							<span>Data de admissão</span>
							<input
								type="text"
								v-model="data.dataAdm"
								class="form-control"
								v-mask="'##/##/####'"
								placeholder="01/01/1970"
							/>
						</div>

						<div class="col-sm-4">
							<span>Parceiro</span>
							<input
								type="text"
								v-model="data.parceiro"
								class="form-control"
								placeholder="PARCEIRO"
							/>
						</div>

						<div class="col-sm-4">
							<span>E-Social</span>
							<input
								type="text"
								v-model="data.eSocial"
								class="form-control"
								placeholder="E-SOCIAL"
							/>
						</div>

						<div class="col-sm-4">
							<span>Celular</span>
							<input
								type="text"
								v-model="data.cel"
								class="form-control"
								v-mask="'(##) #####-####'"
								placeholder="(99) 99999-9999"
							/>
						</div>

						<div class="col-sm-4">
							<span>Email</span>
							<input
								type="text"
								v-model="data.email"
								class="form-control"
								placeholder="EMAIL"
							/>
						</div>

						<div class="col-sm-4">
							<span>Biometria</span>
							<input
								type="text"
								v-model="data.biometria"
								class="form-control"
								placeholder="BIOMETRIA"
							/>
						</div>

						<!--
				<div class="col-sm-4">
					<span>Navio</span>
					<input type="text" v-model="data.navio" class="form-control">
		      	</div> -->

						<div class="clearfix"></div>
						<br />
						<!-- <pre>{{data}}</pre> -->
					</div>
					<div class="modal-footer">
						<button
							type="button"
							class="btn btn-default"
							data-dismiss="modal"
						>
							<i class="fa fa-close"></i> Cancelar
						</button>
						<aBtn
							action="private-save-exams"
							@click="save"
							text="Salvar"
							icon="save"
							type="primary"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import clone from 'js/clone';
	import aBox from 'box';
	import aBtn from 'btn';
	import WBS from 'js/http';
	import toastr from 'toastr';
	import axios from 'axios';

	let reset = {
		nome: '',
		setor: '',
		CPF: '',
		funcao: '',
		CBO: '',
		RG: '',
		passaporte: '',
		dataNasc: '',
		sexo: '',
		dataAdm: '',
		eSocial: '',
		cel: '',
		email: '',
		cargo: '',
		biometria: '',
	};

	export default {
		name: 'ChModalColaboradores',
		components: { aBox, aBtn },
		data() {
			return {
				data: clone(reset),

				navios: [
					{
						navio: 'Não há dados',
					},
				],
				empresas: [
					{
						razao_social: 'Não há dados!',
					},
				],
				cargos: [
					{
						nome_cargo: 'Não há dados',
					},
				],
			};
		},
		methods: {
			open(data) {
				if (data != null) {
					const setMask = {
						CPF: data.CPF.toString().replace(
							/(\d{3})(\d{3})(\d{3})(\d{2})/g,
							'\$1.\$2.\$3\-\$4'
						),
						RG: data.RG.toString().replace(
							/(\d{2})(\d{3})(\d{3})(\d{1})/g,
							'\$1.\$2.\$3\-\$4'
						),
					};
					this.data = clone({ ...data, ...setMask });
				} else this.data = clone(reset);
				$('#CatModal').modal('show');
			},

			save() {
				this.data.CPF = this.data.CPF.toString().replace(
					/[^\w\s]/gi,
					''
				);

				WBS.send('private-save-pessoas', this.data, (resp) => {
					if (resp.status == 'success') {
						toastr.success('Registro alterado com sucesso!');
						this.$emit('update');
						$('#CatModal').modal('hide');
					} else {
						toastr.error(resp.msgs[0]);
					}
				});
			},

			handleLoadNavios() {
				const testParms = {
					pager: {
						page: '0',
						qnt: '50',
					},
				};

				WBS.send('private-read-navios', testParms, (resp) => {
					this.navios = resp.data.table;
					if (this.navios.length - 1 > 0) {
						const lastNavio = this.navios[this.navios.length - 1];
						this.data.navio = lastNavio.navio;
					}
				});
			},

			handleLoadEmpresas() {
				const testParms = {
					pager: {
						page: '0',
						qnt: '50',
					},
				};

				WBS.send('private-read-customers', testParms, (resp) => {
					this.empresas = resp.data.table;
				});
			},

			handleLoadCargos() {
				const testParms = {
					pager: {
						page: '0',
						qnt: '50',
					},
				};

				WBS.send('private-read-cargos', testParms, (resp) => {
					this.cargos = resp.data.table;
				});
			},
		},

		mounted() {
			axios
				.get(
					'https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome'
				)
				.then((response) => (this.estados = response.data));

			this.handleLoadNavios();
			this.handleLoadEmpresas();
			this.handleLoadCargos();
		},
	};
</script>

<style>
	span {
		text-transform: uppercase;
	}
</style>



// WEBPACK FOOTER //
// src/components/cadastros/colaboradores/modal.vue